export const createStringFromTemplate = (
  template: string,
  variables: Record<string, string>,
): string =>
  template.replace(
    new RegExp('{([^{]+)}', 'g'),
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    (_, varKey) => variables[varKey] || '',
  );
